import React, { useEffect, useState } from "react";
import { CreditCard, Check } from "lucide-react";
import { toast } from "sonner";
import client, { apiErr } from "@/lib/api";

export default function AdminPaymentsPage() {
  const [payments, setPayments] = useState([]);
  const load = () => client.get("/admin/payments").then((r) => setPayments(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const confirmTransfer = async (orderId) => {
    try { await client.put(`/admin/orders/${orderId}/confirm-transfer`); toast.success("تم اعتماد التحويل"); load(); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };

  return (
    <div dir="rtl">
      <h2 className="font-head text-[16px] font-bold px-4 pt-5 pb-2 flex items-center gap-1.5"><CreditCard size={17} style={{ color: "var(--k-gold-deep)" }} /> المدفوعات ({payments.length})</h2>
      <div className="px-4 grid grid-cols-1 md:grid-cols-2 gap-2.5 items-start pb-6">
        {payments.length === 0 ? <p className="text-[13px] p-2 md:col-span-2" style={{ color: "var(--k-ink-soft)" }}>لا توجد مدفوعات</p> : payments.map((o) => {
          const paid = o.payStatus === "paid";
          const awaiting = o.payStatus === "awaiting_transfer";
          return (
            <div key={o.orderId} data-testid={`pay-${o.orderId}`} className="rounded-2xl p-3.5" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}>
              <div className="flex justify-between items-center mb-1">
                <span className="font-num font-bold text-[13px]">{o.orderId}</span>
                <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ background: paid ? "var(--k-emerald-tint)" : "var(--k-gold-tint)", color: paid ? "var(--k-emerald)" : "var(--k-gold-deep)" }}>{paid ? "مدفوع" : awaiting ? "بانتظار التحويل" : o.payStatus}</span>
              </div>
              <p className="text-[11.5px]" style={{ color: "var(--k-ink-soft)" }}>{o.payMethodLabel} · <span className="font-num">{o.email}</span></p>
              <div className="flex justify-between text-[12px] mt-1"><span>الإجمالي</span><span className="font-num font-bold">{o.total} د.ل</span></div>
              <div className="flex justify-between text-[11px]" style={{ color: "var(--k-emerald)" }}><span>صافي التاجر</span><span className="font-num">{o.netPayout} د.ل (عمولة {o.commissionTotal})</span></div>
              {awaiting && (
                <button data-testid={`pay-confirm-${o.orderId}`} onClick={() => confirmTransfer(o.orderId)} className="k-tap w-full mt-2 py-2 rounded-lg text-[11.5px] font-bold flex items-center justify-center gap-1.5 text-white" style={{ background: "var(--k-emerald)" }}><Check size={13} /> اعتماد التحويل البنكي</button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
